module.exports = __webpack_public_path__ + "static/developer_alt-677d52188b09daa8e485872cd96e4eb9.svg";